import React, { useState, useEffect } from "react";
import { GenGet, GenPost } from "state/api";
import MsgAlert from "./MsgAlert";
import SubmitButton from "./SubmitButton";
import CustomSelect from "./AdminComponents/CustomSelect";
import LoadingState from "./LoadingState";
import ErrorState from "./ErrorState";

function GenericForm({
  title,
  description,
  fields,
  endpoint,
  defaultData = {},
  updateMode,
  fetchEndPoint,
  pointer 
  
}) {
  const [formData, setFormData] = useState(defaultData);
  const [errorMode, setErrorMode] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(updateMode);
  const [postLoading, setPostLoading] = useState(false);

  const handleFieldChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData({ ...formData, [e.target.name]: e.target.checked ? 1 : 0 });
      return;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await GenGet(`${fetchEndPoint}/${pointer}`);
      console.log(response)
      setFormData(response);

    } catch (err) {
      setErrorMode(err.message);

    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
      if (updateMode && fetchEndPoint && pointer){
        fetchData();
      }
    }, []);

  const handleSubmit = async () => {
    const requiredFields = fields.filter((field) => field.required);
    for (const field of requiredFields) {
      if (!formData[field.name]) {
        setMsg(`O campo "${field.label}" é obrigatório`);
        setTimeout(() => setMsg(null), 3000);
        return;
      }
    }

    try {
      setPostLoading(true)
      const payload = { ...formData };
      const response = await GenPost(endpoint, payload);
      
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false)
      setFormData({});
      
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false)
    }
  };

  const handleUpdate = async () => {
    const requiredFields = fields.filter((field) => field.required);
    for (const field of requiredFields) {
      if (!formData[field.name]) {
        setMsg(`O campo "${field.label}" é obrigatório`);
        setTimeout(() => setMsg(null), 3000);
        return;
      }
    }

    try {
      setPostLoading(true)
      const payload = { ...formData };
      const response = await GenPost(`${endpoint}/${pointer}`, payload);
      
      setMsg(response.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false)
      setFormData({});
      
    } catch (err) {
      setMsg(err.message);
      setTimeout(() => setMsg(null), 3000);
      setPostLoading(false)
    }
  };


  if (loading){
    return(
      <LoadingState />
    )
    
  }

  if(errorMode){
    return(
      <ErrorState />
    )
    
  }

  return (
    <div className="flex flex-col w-full p-2 text-[10pt] h-full bg-slate-100 rounded-lg shadow-md">
      {/* Cabeçalho */}
      <div className="flex w-full sticky -top-6 bg-slate-100 z-20 flex-col">
        <h3 className="text-[14pt]">{title}</h3>
        <p className="text-[9pt] -mt-2">{description}</p>
        <hr />
      </div>

      {/* Campos do Formulário */}
      <div className="flex flex-wrap gap-1 my-2 overflow-y-scroll h-full min-h-[300px] no-scrollbar">
        {fields.map((field) => (
          <div
            key={field.name}
            className={`flex flex-col gap-1 w-full ${
              field.type === "title" ? "w-full" : "md:w-[calc(33%-2rem)]"
            }`}
          >
            {field.type !== "title" && (
              <label className="font-semibold">
                {field.label}
                {field.required && <span className="text-red-500"> *</span>}
              </label>
            )}

            {(() => {
              switch (field.type) {
                case "textarea":
                  return (
                    <textarea
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleFieldChange}
                      placeholder={field.placeholder}
                      className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                  );
                case "select":
                  return (
                    <select
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleFieldChange}
                      className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    >
                      {field.options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  );
                case "checkbox":
                  return (
                    <div
                      onClick={() =>
                        handleFieldChange({
                          target: { name: field.name, value: !formData[field.name] },
                        })
                      }
                      className={`relative w-12 h-6 rounded-full p-1 cursor-pointer transition-colors ${
                        formData[field.name] ? "bg-green-500" : "bg-gray-300"
                      }`}
                    >
                      <div
                        className={`absolute w-4 h-4 bg-white rounded-full shadow-md transform transition-transform ${
                          formData[field.name] ? "translate-x-6" : "translate-x-0"
                        }`}
                      />
                    </div>
                  );
                case "custom-select":
                  return (
                    <CustomSelect
                      name={field.name}
                      label={field.label}
                      data={field.options}
                      value={formData[field.name]}
                      onChange={handleFieldChange}
                      search={field.search}
                    />
                  );
                case "title":
                  return (
                    <div className="flex w-full flex-col mt-2">
                      <hr className="w-full border-gray-300 -mt-1"/>
                      <h3 className="text-[12pt] font-semibold">{field.name}</h3>
                      <p className="text-gray-500 text-[9pt] px-2 -mt-2 z-10">
                        {field.label}
                      </p>
                    </div>
                  );

                case "number":
                  return(
                    <input
                    type={field.type}
                    name={field.name}
                    value={formData[field.name] || ""}
                    min={'0'}
                    onChange={handleFieldChange}
                    placeholder={field.placeholder}
                    className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                  />
                  );
                  
                default:
                  return (
                    <input
                      type={field.type}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleFieldChange}
                      placeholder={field.placeholder}
                      className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                  );
              }
            })()}
          </div>
        ))}
      </div>

      {/* Botão de Envio */}
      <SubmitButton loading={postLoading} onClick={!updateMode ? handleSubmit : handleUpdate} label={!updateMode ? "Cadastrar" : "Atualizar"} />

      {/* Mensagem de Feedback */}
      <MsgAlert alert={msg} />
    </div>
  );
}

export default GenericForm;